import React, {useCallback, useMemo, useState} from 'react';
import {Component} from './inputFIle.styled';
import {Div, Text} from '@/Website/Components/UI';

interface InputFileProps {
  label: string;
  onUpload: (files: File[]) => any;
  multiple?: boolean;
  allowedExtensions: 'all' | 'video' | 'image' | 'doc' | 'excel';
}

const InputFile: React.FC<InputFileProps> = props => {
  const {label, onUpload, multiple, allowedExtensions} = props;
  const [currentFiles, setCurrentFiles] = useState<File[]>([]);
  const handleInputClick = useCallback(() => {
    const input = document.getElementById('upload-input') as HTMLInputElement;
    input?.click();
    input!.value = '';
  }, []);
  const handleDirectoryInputClick = useCallback(() => {
    const input = document.getElementById('upload-directory') as HTMLInputElement;
    input?.click();
    input!.value = '';
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Object.entries(e.target.files || []).map(el => el[1]);
    if (files) {
      const fileList = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        fileList.push(file);
      }

      setCurrentFiles(fileList);
      onUpload(fileList);
    }
  };
  const Extensions = useMemo(() => {
    if (allowedExtensions === 'video') return 'video/*';
    if (allowedExtensions === 'image') return 'image/*';
    if (allowedExtensions === 'doc')
      return 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    if (allowedExtensions === 'excel') return '.xls,.xlsx';
    return '*';
  }, [allowedExtensions]);
  return (
    <Component isUploaded={currentFiles.length > 0}>
      <Div gap={10}>
        <button className="button-label" onClick={handleInputClick}>
          {label}
        </button>
        {multiple && (
          <button className="button-label" onClick={handleDirectoryInputClick}>
            Select directory
          </button>
        )}
      </Div>
      <Text type="Text4">Available formats files: {allowedExtensions}</Text>
      {currentFiles.length > 0 &&
        currentFiles.map((file, i) => (
          <span className="chooser-file-name" key={i}>
            {i + 1}: {file.webkitRelativePath || file.name}
          </span>
        ))}

      <input
        type="file"
        name="Upload"
        accept={Extensions}
        className="upload-file"
        id="upload-input"
        onChange={handleInputChange}
        multiple={multiple}
      />
      {multiple && (
        <input
          type="file"
          name="Upload"
          accept={Extensions}
          className="upload-directory"
          id="upload-directory"
          onChange={handleInputChange}
          multiple={multiple}
          //@ts-ignore
          webkitdirectory="true"
        />
      )}
    </Component>
  );
};

export default InputFile;
